import { baseGrtURL, baseAiURL, baseDeerFlowURL, baseMultimodalDocumentURL, baseMultimodalDocumentURLToken } from '../../httpService/API';
import { hMacAjax } from '../../httpService';
import hmacPlain from '../../httpService/hMacFetch/hmacPlain';
import noTokenfetch from '../../httpService/noTokenFetch';
const reqUrl = `${baseGrtURL}/api/grt-ai`;
const centerUrl = `${baseGrtURL}/api/grt-user-center-service`;
const deerFlowUrl = `${baseDeerFlowURL}/api`;

// DeerFlow AbortController 管理
let deerFlowAbortController = null;
let multimodalAbortController = null;

export const url = {
    getSkillDetail: `${centerUrl}/open/agent/ability`, //获取技能详情
    getAgentDetail: `${centerUrl}/open/agent`, //获取智能体详情
    getAgentList: `${centerUrl}/open/agent/page`, //获取所有智能体列表
    getAllSession: `${reqUrl}/agent/session/list`, //获取所有会话
    deleteSession: `${reqUrl}/agent/session/delete`, //删除会话
    updataName: `${reqUrl}/agent/session/name`, //更新历史会话
    agentSessionUpsert: `${reqUrl}/agent/session/upsert`, //TTS创建会话
    ttsCreateSession: `${reqUrl}/agent/session/name`, //TTS更新会话
    createBatch: `${reqUrl}/agent/messages/create-batch`, //TTS批量保存
    historyRecord: `${baseAiURL}/agent/session/messages`, //获取会话的历史记录
    basicHistoryRecord: `${baseAiURL}/agent/basic/messages`, //获取通用技能历史记录
    chat: `${baseAiURL}/agent/session/chat`, //聊天
    studentName: `${centerUrl}/open/student/v1/name`, //获取学员姓名
    tenantId: `${centerUrl}/open/tenant-id`, //获取租户id
    startRecord: `${centerUrl}/user/ai/trans/v1/start-recording`, //开始转录
    stopRecord: `${centerUrl}/user/ai/trans/v1/stop-recording`, //结束转录
    heartBeat: `${centerUrl}/user/ai/trans/v1/keep-recording`,
    deerFlowChat: `${deerFlowUrl}/chat/background`, //DeerFlow聊天流式接口
    DeerFlowHistory: `${deerFlowUrl}/history`, //DeerFlow历史记录
    DeerFlowStop: `${deerFlowUrl}/stop`, //DeerFlow停止
    aiPpt: `${baseAiURL}/aippt/chat`, //AI PPT获取AI大纲
    aiPptUpdateCatalogs: `${baseAiURL}/aippt/update/catalogs`, //AI PPT更新大纲
    aiPptCover: `${baseAiURL}/aippt/cover`, //AI PPT封面
    aiPptCoverUpdate: `${baseAiURL}/aippt/cover/update`, //AI 修改PPT封面
    aiPptCreate: `${baseAiURL}/aippt/create`, //AI PPT创建
    aiPptResult: `${baseAiURL}/aippt/result`, //AI PPT轮询结果
    aiPptEditor: `${baseAiURL}/aippt/editor`, //AI PPT编辑
    aiPptDownload: `${baseAiURL}/aippt/download`, //AI PPT下载
    multimodalHistory: `${baseAiURL}/multimodal/history`, //多模态历史记录
    multimodalGenerate: `${baseAiURL}/multimodal/generate`, //多模态生成摘要/思维导图/播客
    multimodalGenerateStatus: `${baseAiURL}/multimodal/generate/status`, //多模态生成状态
    multimodalGenerateResult: `${baseAiURL}/multimodal/generate`, //多模态生成结果
    multimodalDocument: `${baseMultimodalDocumentURL}/user/document/v1`, //多模态视频获取
    multimodalDocumentToken: `${baseMultimodalDocumentURLToken}/user/document/v1/vod/asset-token` //多模态视频token获取
};
//获取技能详情
export function handleGetSkillDetail(skillId) {
    return hMacAjax.get(url.getSkillDetail + `/${skillId}`);
}
//获取学员姓名
export function handleGetStudentName(data) {
    return hMacAjax.get(url.studentName, data);
}
// -----------------获取租户ID------------------
export function handleGetTenantId() {
    return hMacAjax.get(url.tenantId);
}
//获取智能体列表
export const handleAgentList = (data) => {
    return hMacAjax.get(url.getAgentList, data);
};
//获取智能体详情
export const handleAgentDetail = (id) => {
    localStorage.setItem('agent6Id', id);
    return noTokenfetch.get(`${url.getAgentDetail}/${id}`);
};
//获取会话列表
export const handleSessionList = (data) => {
    return hMacAjax.post(url.getAllSession, data);
};
//删除指定会话
export const handleDeleteSession = (data) => {
    return hMacAjax.post(url.deleteSession, data);
};
//chatBI更新历史会话
export const handleupdataName = (data) => {
    return hMacAjax.post(url.updataName, data);
};
//TTS创建会话
export const agentSessionUpsertTTS = (data) => {
    return hMacAjax.post(url.agentSessionUpsert, data);
};
//TTS批量保存
export const handleCreateBatchTTS = (data) => {
    return hMacAjax.post(url.createBatch, data);
};
//TTS更新会话
export const ttsUpdateSession = (data) => {
    return hMacAjax.post(url.ttsCreateSession, data);
};
//获取会话的历史记录
export const handleHistoryRecord = (data, isBasic = false) => {
    let reqUrl = isBasic ? url.basicHistoryRecord : url.historyRecord;
    return hMacAjax.post(reqUrl, data);
};
//对话
export const handleChat = (data) => {
    return hMacAjax.post(url.chat, data);
};
//校验登录
export const checkToken = () => {
    return hMacAjax.get(baseGrtURL + '/api/grt-user-service/user/v1/token/check', {});
};
//用户信息
export const getUserInfo = () => {
    return hMacAjax.get(baseGrtURL + '/api/grt-user-service/user/v1/');
};
//是否是学员校验
export const checkBusiness = (data) => {
    return hMacAjax.get(centerUrl + '/agent/student/check', data);
};
//退出登录
export const outLogin = () => {
    return hMacAjax.post(baseGrtURL + '/api/grt-user-service/user/v1/logout');
};

export const startRecord = (data) => {
    return hMacAjax.post(url.startRecord, data);
};
export const stopRecord = (data) => {
    return hMacAjax.post(url.stopRecord, data);
};
export const heartTimeout = (data) => {
    return hMacAjax.post(url.heartBeat, data);
};
//DeerFlow非流式对话
export const handleDeerFlowChat = async (data) => {
    try {
        // 添加请求参数验证
        if (!data || !data.messages || data.messages.length === 0) {
            throw new Error('Invalid request data: messages are required');
        }

        // DeerFlow会话ID处理：
        // 1. 如果thread_id为null/undefined，设为空字符串（新会话）
        // 2. 如果thread_id已存在且不为空，保持原值（继续对话）
        // 3. 如果thread_id为空字符串，保持空字符串（新会话）
        if (data.thread_id === null || data.thread_id === undefined) {
            data.thread_id = '';
        }

        // 设置默认参数
        const requestParams = {
            messages: data.messages,
            max_step_num: 3,
            max_search_results: 3,
            max_plan_iterations: data.max_plan_iterations || 1,
            enable_background_investigation: data.enable_background_investigation !== undefined ? data.enable_background_investigation : false,
            auto_accepted_plan: data.auto_accepted_plan !== undefined ? data.auto_accepted_plan : false,
            // report_style: data.report_style || 'academic',
            chat_info: data.chat_info || {}
        };

        // 只有当thread_id不为空时才添加到请求参数中
        if (data.thread_id && data.thread_id !== '') {
            requestParams.thread_id = data.thread_id;
        }

        // 添加中断反馈（如果存在）
        if (data.interrupt_feedback) {
            requestParams.interrupt_feedback = data.interrupt_feedback;
        }

        return hMacAjax.post(url.deerFlowChat, requestParams);
    } catch (error) {
        console.error('DeerFlow chat error:', error);
        throw error;
    }
};

//DeerFlow历史记录
export const handleDeerFlowHistory = (data) => {
    return hMacAjax.post(url.DeerFlowHistory + `?thread_id=${data.thread_id}`);
};

// 取消DeerFlow聊天请求
export const cancelDeerFlowChat = () => {
    if (deerFlowAbortController) {
        console.log('Cancelling DeerFlow chat request...');
        deerFlowAbortController.abort();
        deerFlowAbortController = null;
        return true;
    }
    return false;
};

// 检查DeerFlow聊天是否处于活跃状态
export const isDeerFlowChatActive = () => {
    return deerFlowAbortController !== null;
};

//DeerFlow停止
export const handleDeerFlowStop = (data) => {
    return hMacAjax.post(url.DeerFlowStop + `?thread_id=${data.thread_id}`);
};

//获取大纲
export const handleAIPPTChat = (data) => {
    if (typeof data.session_id === 'number') {
        data.session_id = String(data.session_id);
    }
    // AI PPT生成可能需要较长时间，设置更长的超时时间（5分钟）
    return hMacAjax.post(url.aiPpt, data, { timeout: 300000 });
};

//更新大纲
export const handleAIPPTUpdateCatalogs = (data) => {
    return hMacAjax.post(url.aiPptUpdateCatalogs, data);
};

//获取封面
export const handleAIPPTCover = (data) => {
    return hMacAjax.post(url.aiPptCover, data, { timeout: 300000 });
};

//更新封面
export const handleAIPPTCoverUpdate = (data) => {
    return hMacAjax.post(url.aiPptCoverUpdate, data, { timeout: 300000 });
};

//创建PPT
export const handleAIPPTCreate = (data) => {
    return hMacAjax.post(url.aiPptCreate, data, { timeout: 300000 });
};

//轮询PPT结果
export const handleAIPPTResult = (data) => {
    return hMacAjax.post(url.aiPptResult, data, { timeout: 300000 });
};

//获取编辑PPT地址
export const handleAIPPTEditor = (data) => {
    return hMacAjax.post(url.aiPptEditor, data, { timeout: 300000 });
};

//获取下载PPT地址
export const handleAIPPTDownload = (data) => {
    return hMacAjax.post(url.aiPptDownload, data, { timeout: 300000 });
};

//多模态历史记录
export const handleMultimodalHistory = (data) => {
    return hMacAjax.post(url.multimodalHistory, data);
};
//多模态生成摘要/思维导图/播客
export const handleMultimodalGenerate = (data) => {
    return hMacAjax.post(url.multimodalGenerate, data);
};

//查询生成状态
export const handleMultimodalGenerateStatus = (data) => {
    return hMacAjax.get(url.multimodalGenerateStatus, data, { timeout: 6000 });
};
//查询生成结果
export const handleMultimodalGenerateResult = (data) => {
    return hMacAjax.get(url.multimodalGenerateResult, data, { timeout: 6000 });
};
//多模态视频获取
export const handleMultimodalDocument = (data) => {
    return hMacAjax.get(url.multimodalDocument + `/${data.id}`);
};
//多模态视频token获取
export const handleMultimodalDocumentToken = (data) => {
    return hMacAjax.get(url.multimodalDocumentToken + `/${data.vod_id}`);
};
